import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { getResetByTag, utilityStyles, rem } from './../../../styles';
import StyledPriceWrapper from './price.wrapper.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("margin-bottom:", rem(3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1iu0zte",
  styles: "text-align:right;legend>div{flex-direction:row-reverse;}"
} : {
  name: "r68kza-alignmentStyles",
  styles: "text-align:right;legend>div{flex-direction:row-reverse;};label:alignmentStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "2fv8qn",
  styles: "text-align:center;legend>div{justify-content:center;}"
} : {
  name: "lpb1m3-alignmentStyles",
  styles: "text-align:center;legend>div{justify-content:center;};label:alignmentStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var alignmentStyles = function alignmentStyles(_ref3) {
  var align = _ref3.align;
  if (align === 'left') {
    return /*#__PURE__*/css("text-align:left;", StyledPriceWrapper, "{justify-content:normal;}" + (process.env.NODE_ENV === "production" ? "" : ";label:alignmentStyles;"));
  } else if (align === 'center') {
    return _ref2;
  } else if (align === 'right') {
    return _ref;
  }
};
var resetStyles = getResetByTag('div');
var StyledPriceAlignment = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1b7jzrh0"
} : {
  target: "e1b7jzrh0",
  label: "StyledPriceAlignment"
})(resetStyles, defaultStyles, alignmentStyles, utilityStyles);
export default StyledPriceAlignment;